import { Input } from '@conteg/ui';
import { useTranslation } from 'react-i18next';

interface ContactInputProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

/**
 * Reusable contact input component
 * Accepts phone number or email (type detection happens on backend)
 * Debouncing is handled at the query level
 */
export function ContactInput({ value, onChange, label }: ContactInputProps) {
  const { t } = useTranslation();

  return (
    <Input
      value={value}
      placeholder={t('Events.Filter.Contact.Placeholder')}
      label={`${label ?? t('Events.Filter.Contact')}`}
      onChange={(ev) => onChange(ev.target.value)}
    />
  );
}
